<template>
  <div class="plan-wrap">
    <div class="seletc-list">
      <el-select v-model="filterData.pkg" filterable style="width: 260px" placeholder="选择产品" @change="clickSearch()">
        <el-option label="全部产品" :value="-1"> </el-option>
        <el-option v-for="item of appList" :key="item.package_name" :label="item.app_name + '（' + item.package_name + '）'" :value="item.package_name">
        </el-option>
      </el-select>
      <el-select style="width: 160px; margin-left: 24px" v-model="filterData.optimizer" placeholder="选择优化师" @change="clickSearch()">
        <el-option label="全部优化师" :value="-1"> </el-option>
        <el-option v-for="item of optimizerList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select style="width: 160px; margin-left: 24px" v-model="filterData.status" placeholder="选择用户状态" @change="clickSearch()">
        <el-option label="全部状态" :value="-1"> </el-option>
        <el-option v-for="item of optionsList.adsetStatus" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 24px"
        class="multiple-select"
        filterable
        v-model="filterData.advertiserId"
        placeholder="全部广告投放账户"
        @change="searchGropuList"
        multiple
        collapse-tags
      >
        <el-option
          v-for="item of advertiserIdList"
          :key="item.advertiserId"
          :label="item.advertiserName + ' (' + item.company + ')'"
          :value="item.advertiserId"
        >
        </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 24px"
        class="multiple-select"
        v-model="filterData.campaignId"
        placeholder="选择广告组"
        multiple
        filterable
        collapse-tags
        @change="clickSearch()"
      >
        <el-option v-for="item of campaignIdList" :key="item.campaign_id" :label="item.campaign_name + ' (' + item.campaign_id + ')'" :value="item.campaign_id">
        </el-option>
      </el-select>
      <el-select style="width: 160px; margin-left: 24px" v-model="filterData.deliveryPlacement" placeholder="选择投放位置" @change="clickSearch()">
        <el-option label="全部投放位置" :value="-1"> </el-option>
        <el-option label="今日头条" value="INVENTORY_FEED"></el-option>
        <el-option label="火山小视频" value="INVENTORY_HOTSOON_FEED"></el-option>
        <el-option label="番茄小说" value="INVENTORY_TOMATO_NOVEL"></el-option>
        <el-option label="西瓜视频" value="INVENTORY_VIDEO_FEED"></el-option>
        <el-option label="通投智选" value="INVENTORY_UNIVERSAL"></el-option>
        <el-option label="抖音" value="INVENTORY_AWEME_FEED"></el-option>
        <el-option label="穿山甲" value="INVENTORY_UNION_SLOT"></el-option>
        <el-option label="ohayoo精品游戏" value="UNION_BOUTIQUE_GAME"></el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px; margin-left: 24px"
        value-format="yyyyMMdd"
        :clearable="false"
        @change="clickSearch()"
      >
      </el-date-picker>
      <!-- <el-button class="submit-btn" type="primary" @click="clickSearch()"
        >提交</el-button
      > -->
    </div>
    <div class="content-wrap">
      <div class="btn-list">
        <el-input
          placeholder="请输入广告计划名称/ID"
          prefix-icon="el-icon-search"
          v-model="filterData.search"
          class="search-input"
          style="width: 190px"
          @change="inputSearch"
        >
        </el-input>
        <div class="mult-wrap">
          <el-button class="top-btn" style="margin-right: 16px" @click="showPlBox = true">
            <svg-icon iconClass="pl" className="pl-icon"></svg-icon>批量操作</el-button
          >
          <span class="piliang border-bg" v-show="showPlBox">
            <span class="batch-span"
              >已选择<a>{{ checkedList.length }}</a
              >账户</span
            >
            <div class="icon-list">
              <el-tooltip content="开始" placement="top">
                <svg-icon iconClass="start" className="batch-icon" @click="editStatus('enable')"></svg-icon>
              </el-tooltip>
              <el-tooltip content="暂停" placement="top">
                <svg-icon iconClass="stop" className="batch-icon" @click="editStatus('disable')"></svg-icon>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <i class="el-icon-delete batch-icon" @click="editStatus('delete')"></i>
              </el-tooltip>
              <span class="close-icon">
                <svg-icon iconClass="close" className="close-btn" @click="showPlBox = false"></svg-icon>
              </span>
            </div>
          </span>
        </div>
        <!-- 选择字段弹框 -->
        <select-field :options="fieldOptions" :staticOptions="staticOptions" @changeColumn="generateCols" :type="3"></select-field>
        <!-- <el-button class="top-btn" icon="el-icon-refresh" style="margin-left: 16px" @click="asyncData()">刷新数据</el-button> -->
        <el-button class="top-btn" icon="el-icon-download" style="margin-left: 16px" @click="downloadReport" :loading="downloadLoading">下载报表</el-button>
      </div>
      <div class="table-wrap">
        <el-table @selection-change="handleSelectionChange" :data="tableList" :max-height="tableMaxHeight" v-loading="loading">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column v-for="item of staticOptions" :key="item.value" :prop="item.value" :label="item.label" :min-width="item.width" :fixed="true">
            <template slot-scope="scope">
              <div v-if="item.value === 'ad_name'">
                <span class="name-link" @click="checkCreative(scope.row)">{{ scope.row.ad_name }}</span>
              </div>
              <span v-else>{{ scope.row[item.value] }}</span>
            </template>
          </el-table-column>
          <el-table-column v-for="item of tableCols" :key="item.value" :prop="item.value" :label="item.label" :min-width="item.width" :fixed="item.fixed">
            <template slot-scope="scope">
              <span>{{ scope.row[item.value] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="80">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isActive" @change="(value) => changeSingleType(scope.row, value)"> </el-switch>
              <!-- <el-button style="margin-left: 6px" type="text">编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import SelectField from "@/components/selectField.vue";
import { attribute, baseData, appData } from "@/config/fieldData";
import { getDesigner, getAdvertiserInfo, queryCampaign, queryAdSetData, updateAdStatus, refreshReportData } from "@/api/promotionReport.js";
import { getCommonProductList } from "@/api/api.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import moment from "moment";
import selectOptions from "./selectOptions.js";
import { formatTableList } from "../formatData.js";
export default {
  name: "PlanTable",
  components: {
    SvgIcon,
    SelectField,
  },
  data() {
    return {
      loading: false,
      appList: [],
      optimizerList: [],
      advertiserIdList: [],
      campaignIdList: [],
      optionsList: selectOptions,
      filterData: {
        pkg: -1,
        optimizer: -1,
        status: -1,
        advertiserId: [],
        campaignId: [],
        deliveryPlacement: -1,
        time: [moment().subtract(7, "days").format("YYYYMMDD"), moment().subtract(1, "days").format("YYYYMMDD")],
        search: "",
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      fieldOptions: [
        { title: "属性数据", list: attribute.plan },
        { title: "基础数据", list: baseData },
        { title: "应用数据", list: appData },
      ],
      staticOptions: [{ label: "广告计划名称", value: "ad_name", width: "280" }],
      tableList: [],
      tableCols: [],
      showPlBox: false,
      tableMaxHeight: window.innerHeight - 345,
      checkedList: [],
      downloadLoading: false,
    };
  },
  mounted() {
    this.initSelectOptions();
  },
  methods: {
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.showPlBox = true;
      } else {
        this.showPlBox = false;
      }
      this.checkedList = e;
    },
    initSelectOptions() {
      getCommonProductList({ platType: 1 }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      getDesigner().then((res) => {
        if (res.code === "0000") {
          this.optimizerList = res.tags;
        }
      });
      getAdvertiserInfo().then((res) => {
        if (res.code === "0000") {
          this.advertiserIdList = res.advertiseInfos;
        }
      });
      this.searchGropuList();
    },
    //根据账号查询广告组
    searchGropuList(ifSearch) {
      let parmas = {};
      if (this.filterData.advertiserId.length > 0) {
        this.filterData.campaignId = [];
        parmas.advertiserId = this.filterData.advertiserId.join();
      }
      queryCampaign(parmas).then((res) => {
        if (res.code === "0000") {
          this.campaignIdList = res.advertiserDataDtoVos;
          //是否需要查询表格（初始化时不用查询）
          if (ifSearch) {
            this.clickSearch();
          }
        }
      });
    },
    clickSearch(filterData) {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData(filterData);
    },
    formatData() {
      let parmas = {
        page: this.pageData.page,
        size: this.pageData.size,
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (parmas[key] = checkData.join());
        } else {
          parmas[key] = checkData;
        }
      }
      return parmas;
    },
    formatTableData(list) {
      return list.map((item) => {
        let curType = this.optionsList.adsetStatus.find((typeItem) => typeItem.value === item.data_status);
        item.data_status = curType ? curType.label : "-";
        item.isActive = item.opt_status === "AD_STATUS_ENABLE" ? true : false;
        //通用字段
        formatTableList(item);
        return item;
      });
    },
    searchData(filterData) {
      if (filterData) {
        //条件查询
        this.filterData.pkg = -1;
        this.filterData.optimizer = -1;
        this.filterData.status = -1;
        this.filterData.advertiserId = [filterData.advertiser_id];
        this.filterData.campaignId = [];
        this.filterData.deliveryPlacement = -1;
        this.filterData.time = filterData.time;
        this.filterData.search = "";
        filterData.campaign_id ? (this.filterData.campaignId = [filterData.campaign_id]) : "";
      }
      let parmas = this.formatData();
      this.loading = true;
      queryAdSetData(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.tableList = this.formatTableData(res.data.list);
          this.pageData.total = res.data.total;
        }
      });
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "app_name",
          "data_status",
          "budget",
          "cpa_bid",
          "create_time",
          "cost",
          "show_cnt",
          "click_cnt",
          "ctr",
          "avg_click_cost",
          "avg_show_cost",
          "convert_cnt",
          "convert_cost",
        ];
      }
      let allFieldsMap = attribute.plan.concat(baseData, appData); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    downloadReport() {
      this.downloadLoading = true;
      let parmas = this.formatData();
      delete parmas.page;
      delete parmas.size;
      queryAdSetData(parmas).then((res) => {
        this.downloadLoading = false;
        if (res.code === "0000") {
          const dataList = this.formatTableData(res.data.list);
          //表头映射
          const HeaderData = {};
          this.staticOptions.concat(this.tableCols).forEach((item) => {
            HeaderData[item.value] = item.label;
          });
          downLoadWrokSheet(dataList, "计划.xlsx", HeaderData);
        }
      });
    },
    //批量修改状态
    editStatus(status) {
      if (this.checkedList.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
        return;
      } else {
        let params = {
          ad_list: JSON.stringify(
            this.checkedList.map((item) => {
              return {
                advertiser_id: item.advertiser_id,
                ad_id: item.ad_id,
              };
            })
          ),
          ops_status: status,
        };
        this.commitChange(params);
      }
    },
    changeSingleType(item, type) {
      let params = {
        ad_list: JSON.stringify([
          {
            advertiser_id: item.advertiser_id,
            ad_id: item.ad_id,
          },
        ]),
        ops_status: type ? "enable" : "disable",
      };
      this.commitChange(params);
    },
    commitChange(data) {
      updateAdStatus(data).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "状态修改成功",
            type: "success",
          });
          this.searchData();
        }
      });
    },
    checkCreative(rowData) {
      this.$emit("checkTable", {
        name: "CreativeTable",
        data: Object.assign({}, rowData, { time: this.filterData.time }),
      });
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.clickSearch();
      }, 500);
    },
    asyncData() {
      refreshReportData().then(() => {});
      this.$message({
        message: "数据同步中，预计半小时同步成功",
        type: "success",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.plan-wrap {
  .seletc-list {
    display: flex;
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);
    .multiple-select {
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .wenhao-icon {
      margin-left: 12px;
      cursor: pointer;
    }
    .submit-btn {
      margin-left: auto;
      padding: 0 20px;
    }
  }
  .content-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      align-items: center;
      height: 45px;
      .mult-wrap {
        display: flex;
        align-items: center;
        margin-right: auto;
      }
      .top-btn {
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 1);
        background: rgba(255, 255, 255, 1);
        .pl-icon {
          margin-right: 8px;
        }
      }
      .search-input {
        width: 160px;
        margin-right: 24px;
        /deep/ .el-input__icon {
          line-height: 35px;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      .name-link {
        color: #1890ff;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: #0285ff;
        }
      }
    }
  }
}
.piliang {
  height: 45px;
  line-height: 45px;
  padding-left: 12px;
  margin-left: 12px;
  display: flex;
  justify-content: space-between;
  .batch-span {
    font-size: 13px;
    color: rgba(0, 0, 0, 1);
    a {
      color: rgba(24, 144, 255, 1);
      margin: 0 5px;
    }
  }
  .icon-list {
    margin-left: 58px;
    color: rgba(24, 144, 255, 1);
  }
  .batch-icon {
    margin-right: 26px;
    cursor: pointer;
  }
  .close-btn {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    margin: 0 16px 0 40px;
    cursor: pointer;
  }
}
</style>
